import { render, staticRenderFns } from "./ReactMountContaCorrente.vue?vue&type=template&id=dc73f034"
import script from "./ReactMountContaCorrente.vue?vue&type=script&lang=ts"
export * from "./ReactMountContaCorrente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc73f034')) {
      api.createRecord('dc73f034', component.options)
    } else {
      api.reload('dc73f034', component.options)
    }
    module.hot.accept("./ReactMountContaCorrente.vue?vue&type=template&id=dc73f034", function () {
      api.rerender('dc73f034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountContaCorrente.vue"
export default component.exports